import { OccupancySelection } from './search-occupancy.model';
import { AgeGroup } from '@app/model/deal.model';
import { TranslateService } from '@ngx-translate/core';

export const compileOccupancyString = (
    occupancySelection: OccupancySelection
): string => {
    if (!occupancySelection) {
        return 'Add Guests';
    }

    const { adults, children } = occupancySelection;
    const adultsString = adults === 1 ? '1 Adult' : `${adults} Adults`;
    const nrOfChildren = children.length;
    const childrenString =
        nrOfChildren === 0
            ? ''
            : nrOfChildren === 1
            ? ' • 1 Child'
            : ` • ${nrOfChildren} Children`;
    return `${adultsString}${childrenString}`;
};

export const compileOccupancyStringWithAges = (
    occupancyString: string,
    { children }: OccupancySelection
): string => {
    if (!children.length) return occupancyString;

    const ageText = children.length === 1 ? 'Age' : 'Ages';

    return `${occupancyString} (${ageText} ${children.join(', ')})`;
};

export const compileOccupancyQueryString = (
    occupancySelection: OccupancySelection
): string => {
    const { adults, children } = occupancySelection;
    const dto = {
        adults,
        children: children,
    };

    return JSON.stringify(dto);
};

export const extractOccupancyFromQueryString = (
    queryString: string
): OccupancySelection => {
    const urlParams = new URLSearchParams(queryString);
    const adults = Number(urlParams.get('adults'));
    const children = urlParams.getAll('children').map((c) => Number(c));
    return { adults, children };
};

export const getOccupancyLabelFromAgeGroups = (
    ageGroups: AgeGroup[],
    translate: TranslateService
): string => {
    if (!ageGroups || !ageGroups.length) return '';
    return ageGroups
        .filter((ageGroup) => ageGroup.qty > 0)
        .map((ageGroup) => {
            const qty = ageGroup.qty;
            let ageGroupType = ageGroup.ageGroupType;

            if (qty > 1) {
                if (ageGroupType === 'Child') ageGroupType = 'Children';
                else ageGroupType = `${ageGroupType}s`;
            }

            return `${qty} ${translate.instant('AgeGroup.' + ageGroupType)}`;
        })
        .join(' + ');
};
